import { GlButton, GlFormRadio, GlFormRadioGroup, GlPopover } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import { InternalEvents } from '../../../tracking/index.js?vue3';
import { SIDEBAR_NAV_MODE_ITEMS, SIDEBAR_PREFERENCES_TOGGLE_ID, FEATURE_LIBRARY_TRIGGER_ID } from '../../constants';
import { EVENT_SELECT_SIDEBAR_NAVIGATION_MODE_IN_SIDEBAR_PREFERENCES } from '../../tracking_constants';
const STEP_LAYOUT = 1;
const STEP_CATALOG = 2;
const STEP_COUNT = 2;
const AUTOFOCUSED_LANDMARK_SELECTOR = '[autofocus]:not(input, textarea, select, [contenteditable]:not([contenteditable="false"]))';
export default {
    name: 'TailoredNavigationOnboardingPopover',
    components: {
        GlButton,
        GlFormRadio,
        GlFormRadioGroup,
        GlPopover
    },
    mixins: [
        InternalEvents.mixin()
    ],
    STEP_LAYOUT,
    STEP_CATALOG,
    navModeOptions: SIDEBAR_NAV_MODE_ITEMS,
    inject: [
        'panelType'
    ],
    props: {
        navMode: {
            type: String,
            required: true
        },
        // Hides the popover without destroying this component, so the current step
        // survives while the sidebar is collapsed.
        visible: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'catalog-step',
        'nav-mode-change',
        'close'
    ],
    data () {
        return {
            step: STEP_LAYOUT,
            // The popover remounts whenever it's hidden and shown again (sidebar collapse,
            // catalog item scrolled away), so only take focus on each step's first show.
            focusOnShow: true
        };
    },
    computed: {
        target () {
            return this.step === STEP_CATALOG ? FEATURE_LIBRARY_TRIGGER_ID : SIDEBAR_PREFERENCES_TOGGLE_ID;
        },
        isFirstStep () {
            return this.step === STEP_LAYOUT;
        },
        isLastStep () {
            return this.step === STEP_COUNT;
        },
        stepLabel () {
            return sprintf(__('Step %{currentStep} of %{stepsTotal}'), {
                currentStep: this.step,
                stepsTotal: STEP_COUNT
            });
        }
    },
    watch: {
        step (step) {
            this.$emit('catalog-step', step === STEP_CATALOG);
        }
    },
    beforeDestroy () {
        this.popoverElement?.removeEventListener('keydown', this.onPopoverKeydown);
    },
    methods: {
        onShown ({ relatedTarget }) {
            // The popover remounts on each step, so move the listener to the new element.
            this.popoverElement?.removeEventListener('keydown', this.onPopoverKeydown);
            // Listen on the whole popover so Esc also works from the title's close button.
            this.popoverElement = relatedTarget;
            this.popoverElement?.addEventListener('keydown', this.onPopoverKeydown);
            // Focus the popover itself (it has tabindex="-1") so it is read from the top and Tab
            // starts at its first control. It opens by itself, so only take focus nobody holds.
            if (!this.focusOnShow) return;
            const autoOpened = !this.stepChanged;
            this.focusOnShow = false;
            this.stepChanged = false;
            if (autoOpened && !this.focusIsFree()) return;
            this.popoverElement?.focus();
        },
        focusIsFree () {
            const { activeElement } = document;
            if (!activeElement || activeElement === document.body) return true;
            // Pages autofocus the top bar landmark on load, which the user hasn't chosen.
            return activeElement.matches(AUTOFOCUSED_LANDMARK_SELECTOR);
        },
        close () {
            // The popover is about to be destroyed, so hand focus back to its anchor
            // instead of letting it fall to <body>.
            document.getElementById(this.target)?.focus();
            this.$emit('close');
        },
        onPopoverKeydown (event) {
            if (event.key !== 'Escape') return;
            event.stopPropagation();
            this.close();
        },
        goToStep (step) {
            this.focusOnShow = true;
            this.stepChanged = true;
            this.step = step;
        },
        onNavModeChange (mode) {
            if (mode === this.navMode) return;
            // Same event the in-sidebar dropdown fires, so the choice is counted
            // uniformly regardless of where it was made.
            this.trackEvent(EVENT_SELECT_SIDEBAR_NAVIGATION_MODE_IN_SIDEBAR_PREFERENCES, {
                label: this.panelType,
                property: mode
            });
            // SuperSidebar owns persistence (localStorage) and live state, so it
            // stays the single writer shared with the in-sidebar dropdown.
            this.$emit('nav-mode-change', mode);
        }
    }
};
